import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'custom-select',
    template: '<ng-content></ng-content>',
    styleUrls: ['./custom-select.component.scss'],
    // encapsulation: ViewEncapsulation.ShadowDom
})
export class CustomSelectComponent {}
